/**
 * 通用槽位配置 — 前端上传素材选择目标槽位的单一来源。
 * 当后端 asset:request 返回动态槽位时优先使用动态数据；此处提供默认选项。
 */

export interface SlotOption { label: string; value: string; }

/** 通用图片槽位选项 */
export const DEFAULT_IMAGE_SLOT_OPTIONS: SlotOption[] = [
  { label: '🎨 背景 (background)', value: 'background' },
  { label: '🧑 角色 (character)', value: 'character' },
  { label: '🚧 障碍物 (obstacle)', value: 'obstacle' },
  { label: '📦 道具 (item)', value: 'item' },
  { label: '🏁 地面 (ground)', value: 'ground' },
  { label: '🔘 CTA按钮 (cta_button)', value: 'cta_button' },
  { label: '🏆 胜利弹窗 (popup_win)', value: 'popup_win' },
  { label: '❌ 失败弹窗 (popup_lose)', value: 'popup_lose' },
  { label: '🚪 开始弹窗 (popup_intro)', value: 'popup_intro' },
  { label: '👆 引导手势 (guide_hand)', value: 'guide_hand' },
  { label: '🟦 消除元素1 (tile_0)', value: 'tile_0' },
  { label: '🟧 消除元素2 (tile_1)', value: 'tile_1' },
  { label: '🟩 消除元素3 (tile_2)', value: 'tile_2' },
  { label: '🟪 消除元素4 (tile_3)', value: 'tile_3' },
  { label: '🟨 消除元素5 (tile_4)', value: 'tile_4' },
  { label: '🟫 消除元素6 (tile_5)', value: 'tile_5' },
  { label: '🚗 水平车辆 (car_h)', value: 'car_h' },
  { label: '🚙 竖直车辆 (car_v)', value: 'car_v' },
  { label: '🚘 目标车辆 (car_target)', value: 'car_target' },
  { label: '🅿️ 停车场背景 (parking_bg)', value: 'parking_bg' },
];

/** 通用音频槽位选项 */
export const DEFAULT_AUDIO_SLOT_OPTIONS: SlotOption[] = [
  { label: '🎵 背景音乐 (bgmSrc)', value: 'bgmSrc' },
  { label: '👆 点击音效 (clickSoundSrc)', value: 'clickSoundSrc' },
  { label: '⭐ 得分音效 (scoreSoundSrc)', value: 'scoreSoundSrc' },
  { label: '💥 碰撞音效 (crashSoundSrc)', value: 'crashSoundSrc' },
];

/** 生成模式选项 */
export const GENERATION_MODE_OPTIONS: SlotOption[] = [
  { label: '自动选择', value: 'auto' },
  { label: '内置模板', value: 'template' },
  { label: '蓝图拼装', value: 'blueprint' },
  { label: 'Cocos源码', value: 'cocos' },
  { label: 'Cocos生成', value: 'cocos-generation' },
  { label: '视频转试玩', value: 'video' },
];

/** 将后端 asset:request 槽位数据转为 Select 选项。 */
export function buildSlotOptionsFromCoverage(
  slots: Array<{ label: string; key: string; provided?: boolean }>,
): SlotOption[] {
  return slots.map((s) => ({ label: `${s.label} (${s.key})`, value: s.key }));
}
